import React from "react";
import { Link } from "react-router-dom";
import "./RentalsGrid.css";
import { FiArrowRight, FiHome } from "react-icons/fi";

/* Static cards (no backend) */
const CARDS = [
  {
    key: "lofts",
    title: "Lofts",
    to: "/spaces/lofts",
    image: "./space1.webp", // airy loft interior
  },
  {
    key: "commercial",
    title: "Commercial",
    to: "/spaces/commercial",
    image: "./space2.jpg", // modern office/commercial
  },
];

export default function RentalsGrid({
  title = "Our Spaces",
}) {
  return (
    <section className="rg-section">
      <div className="rg-container">
        {/* Header */}
        <div className="rg-header">
          <div className="rg-header-content">
            <h2 className="rg-title">
              {title}
              <span className="rg-title-accent" />
            </h2>
            <p className="rg-subtitle">Quality Residential and Commercial Spaces in the Heart of Tacoma</p>
          </div>
        </div>

        {/* Grid: exactly 2 cards on desktop */}
        <div className="rg-grid rg-grid--two">
          {CARDS.map((card) => (
            <article className="rg-card" key={card.key}>
              <div className="rg-media">
                {card.image ? (
                  <img src={card.image} alt={card.title} loading="lazy" />
                ) : (
                  <div className="rg-media-placeholder">
                    <FiHome />
                  </div>
                )}

                <div className="rg-overlay">
                  <Link className="rg-overlay-link" to={card.to}>
                    View Details <FiArrowRight />
                  </Link>
                </div>
              </div>

              <div className="rg-body">
                <div className="rg-card-header">
                  <h3 className="rg-card-title">{card.title}</h3>
                </div>

                <div className="rg-footer">
                  <Link className="rg-link" to={card.to}>
                    Details <FiArrowRight className="rg-link-icon" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
